import { render, staticRenderFns } from "./PriceDialog.vue?vue&type=template&id=78618104&scoped=true&"
import script from "./PriceDialog.vue?vue&type=script&lang=js&"
export * from "./PriceDialog.vue?vue&type=script&lang=js&"
import style0 from "./PriceDialog.vue?vue&type=style&index=0&id=78618104&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "78618104",
  null
  
)

/* custom blocks */
import block0 from "./PriceDialog.vue?vue&type=custom&index=0&blockType=messages"
if (typeof block0 === 'function') block0(component)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VTooltip } from 'vuetify/lib/components/VTooltip';
installComponents(component, {VBtn,VIcon,VTooltip})
